module.exports = __webpack_public_path__ + "static/img/step-3.709d72d9.png";